import React from 'react';
import Prism from 'prismjs';
import 'prismjs/themes/prism.css';

const ScriptElement = ({ scriptText }) => (
    <pre
        style={{
            width: window.innerWidth * 0.7,
            overflow: 'auto',
            backgroundColor: 'inherit',
            marginBottom: '1.5625rem',
        }}
    >
        <code
            className="language-html"
            dangerouslySetInnerHTML={{
                __html: Prism.highlight(scriptText, Prism.languages.html),
            }}
        />
    </pre>
);

export default ScriptElement;
